var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-simple-table', {
    staticClass: "v-data-table--default v-data-table--no-hover"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('v-currency-field', _vm._b({
    staticClass: "text-align-right-input",
    attrs: {
      "outlined": "",
      "hide-details": "",
      "type": "number",
      "suffix": "원"
    },
    on: {
      "input": _vm.emit
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function () {
        return [_c('v-btn', _vm._b({
          attrs: {
            "x-large": "",
            "outlined": "",
            "color": "primary"
          },
          on: {
            "click": _vm.togglePointMax
          }
        }, 'v-btn', {
          disabled: _vm.disabled
        }, false), [_vm._v("전체사용")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.point,
      callback: function ($$v) {
        _vm.point = $$v;
      },
      expression: "point"
    }
  }, 'v-currency-field', {
    max: _vm.max,
    disabled: _vm.disabled
  }, false))], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }